import { z } from "zod";

export const individualEmployerRegistrationSchema = z.object({
  name: z.string().min(1, "Nama harus diisi"),
});

export type IndividualEmployerRegistrationDto = z.infer<
  typeof individualEmployerRegistrationSchema
>;

export interface IndividualEmployerRegistrationResponse {
  data: {
    id: string;
    name: string;
    email: string;
    username?: string;
    [key: string]: unknown;
  };
}
